import { Box, Typography } from '@mui/material';
import Container from '@mui/material/Container';
import React from 'react';
import PreferencesTable from '../components/preferences/PreferencesTable';
import { headerProps, headerTypographyProps } from '../styles/sxStyling';
import { PREFERENCES_VALID_KEYS } from '../types/Preference';
import { UserSettingsCollapseKeys } from '../types/User';

const Preferences: React.FC = () => {
  return (
    <Container>
      <Box sx={headerProps}>
        <Typography {...headerTypographyProps}>Preferences</Typography>
      </Box>
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.ACCOUNT_STATUS} collapseId={UserSettingsCollapseKeys.PREFERENCES_ACCOUNT_STATUS} />
      <PreferencesTable
        preferenceKey={PREFERENCES_VALID_KEYS.ACCOUNT_SCHOOL_DISTRICT}
        collapseId={UserSettingsCollapseKeys.PREFERENCES_ACCOUNT_SCHOOL_DISTRICT}
      />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.ACCOUNT_TYPE} collapseId={UserSettingsCollapseKeys.PREFERENCES_ACCOUNT_TYPE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.EVENT_TYPE} collapseId={UserSettingsCollapseKeys.PREFERENCES_EVENT_TYPES} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.EVENT_LOCATION} collapseId={UserSettingsCollapseKeys.PREFERENCES_EVENT_LOCATIONS} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.TASK_TYPE} collapseId={UserSettingsCollapseKeys.PREFERENCES_TASK_TYPE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.CONTACT_ROLE} collapseId={UserSettingsCollapseKeys.PREFERENCES_CONTACT_ROLE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.CONTACT_TITLE} collapseId={UserSettingsCollapseKeys.PREFERENCES_CONTACT_TITLE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.EMPLOYEE_ROLE} collapseId={UserSettingsCollapseKeys.PREFERENCES_EMPLOYEE_ROLE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.EMPLOYEE_TITLE} collapseId={UserSettingsCollapseKeys.PREFERENCES_EMPLOYEE_TITLE} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.TAG} collapseId={UserSettingsCollapseKeys.PREFERENCES_TAG} />
      <PreferencesTable preferenceKey={PREFERENCES_VALID_KEYS.ADDRESS_TYPE} collapseId={UserSettingsCollapseKeys.PREFERENCES_ADDRESS_TYPE} />
    </Container>
  );
};

export default Preferences;
